import MonthDay from './monthDay-picker';

export default MonthDay;



// WEBPACK FOOTER //
// ./src/FcComponents/monthDay/index.js